<!-- Premium Upgrade Card -->
<ddc-rotating-border-card>
  <mat-card class="upgrade-card">
    <div class="upgrade-container">
      <div class="upgrade-content">
        <div class="upgrade-badge">
          <mat-icon class="premium-icon">workspace_premium</mat-icon>
          <span class="premium-text">UPGRADE TO PRO</span>
        </div>
        <div class="upgrade-features">
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>Access to Lingo AI</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>AI-Generated Dictionaries</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>AI-Generated Quizzes</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>AI-Generated Figures</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>Flash Cards</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>Matching Games</span>
          </div>
          <div class="feature-item">
            <mat-icon class="feature-icon">check_circle</mat-icon>
            <span>Export to PDF</span>
          </div>
        </div>

        <div class="upgrade-action">
          <ddc-button-u-one
            [_color]="'primary'"
            [_dynamicRoute]="'/pricing'"
            [_hasBorder]="true"
            [_icon]="'auto_awesome'"
            [_label]="'Upgrade Now'"
          ></ddc-button-u-one>

          <div class="upgrade-price">
            <span class="price-text">Starting at <strong>$2.9/month</strong></span>
            <span class="trial-text">Limited Time Offer</span>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</ddc-rotating-border-card>
